export default __webpack_public_path__ + "static/media/logo.b6409888.svg";